import { DATE, DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'atom... Remove this comment to see the full error message
import { deref, unwatch, watch } from 'atom';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { isResolved } from 'reference-resolvers/utils';
import After from 'customer-data-filters-ui/filterQueryFormat/operator/After';
import Before from 'customer-data-filters-ui/filterQueryFormat/operator/Before';
import PropertyChangedNameAndValueField from '../../converters/objectSeg/fieldDefinitions/PropertyChangedNameAndValueField';
import FilterOperatorPropertyInputOption from './FilterOperatorPropertyInputOption';
import FilterOperatorType from 'customer-data-filters-ui/components/propTypes/FilterOperatorType';
import PropTypes from 'prop-types';
import { Component, createRef } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ReferenceResolverType from 'reference-resolvers/schema/ReferenceResolverType';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { Select } from 'foundations-components/transitional/components/Select';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import I18n from 'I18n';
import FilterOperatorErrorType from 'customer-data-filters-ui/components/propTypes/FilterOperatorErrorType';
import { hasAutomationSupportSelectingSensitiveProperties, hasPropertyValueChangedRestrictions } from '../../permissions/gates';
import Raven from 'raven-js';
import { isFieldRestricted, RESTRICTED_OPTION_PROPS } from 'customer-data-filters-ui/utils/fieldLevelPermissions';
import { isRelativeTimePropertyReferenceRecord } from '../../utils/isRelativeTimeProperty';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyValueChangedRestrictedProperties = ['lastmodifieddate', 'hs_lastmodifieddate'];
class FilterOperatorPropertyInput extends Component {
  constructor() {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1-2 arguments, but got 0.
    super();
    this.onOpenChange = evt => {
      this.setState({
        isOpen: evt.target.value
      });
      if (evt.target.value === false && this.props.onBlur) {
        this.props.onBlur();
      }
    };
    this.handleChange = ({
      target: {
        value: nextValue
      }
    }) => {
      const {
        condition,
        fieldName,
        onChange
      } = this.props;
      let updatedCondition;
      if (condition.constructor === After || condition.constructor === Before) {
        var _this$state$options$f;
        const optionType = (_this$state$options$f = this.state.options.find(o => o.value === nextValue)) === null || _this$state$options$f === void 0 ? void 0 : _this$state$options$f.type;
        updatedCondition = condition.merge({
          [fieldName]: nextValue,
          referencedPropertyType: optionType
        });
      } else {
        updatedCondition = condition.merge({
          [fieldName]: nextValue
        });
      }
      const onChangeEvent = syntheticEvent(updatedCondition);
      onChange(onChangeEvent, this.state.isOpen);
    };
    this.handleOptionsChange = referenceRecords => {
      if (isResolved(referenceRecords)) {
        const options = referenceRecords.filter(record => !record.referencedObject.get('hidden')).filter(record => !isRelativeTimePropertyReferenceRecord(record.referencedObject)).map(record => {
          const propertyDescription = record.getIn(['referencedObject', 'description']);
          const propertyName = record.id;
          const helpText = propertyDescription;
          const label = record.label || propertyName;
          const option = {
            value: propertyName,
            text: label,
            help: helpText,
            type: record.getIn(['referencedObject', 'type']),
            dataSensitivity: record.getIn(['referencedObject', 'dataSensitivity'])
          };
          const isRestricted = isFieldRestricted(record.getIn(['referencedObject', 'accessLevel']));
          if (isRestricted) {
            Object.assign(option, RESTRICTED_OPTION_PROPS);
          }
          return option;
        }).toArray();
        this.setState({
          loading: false,
          options
        });
      }
    };
    this.state = {
      loading: true,
      options: [],
      isOpen: false
    };
    this.inputRef = /*#__PURE__*/createRef();
    this.referenceAtom = null;
  }
  componentDidMount() {
    const {
      condition,
      resolver
    } = this.props;
    if (resolver && typeof resolver.all !== 'function') {
      Raven.captureException(new Error(`[Expected a reference resolver] resolver does not have 'all' function; condition.field: ${JSON.stringify(condition.field)}`));
    }
    if (resolver && resolver.all) {
      this.referenceAtom = resolver.all();
      watch(this.referenceAtom, this.handleOptionsChange);
      this.handleOptionsChange(deref(this.referenceAtom));
    }
  }
  componentWillUnmount() {
    if (this.referenceAtom) {
      unwatch(this.referenceAtom, this.handleOptionsChange);
    }
  }
  focus() {
    this.inputRef.current.focus();
  }
  getOptions() {
    var _condition$field;
    const {
      condition,
      getIsUngated
    } = this.props;
    let options = this.state.options;
    if (condition instanceof After || condition instanceof Before) {
      options = options.filter(option => option.type === DATE_TIME || option.type === DATE);
    }
    const preventUseOfSensitiveProperties = !hasAutomationSupportSelectingSensitiveProperties();
    if (preventUseOfSensitiveProperties && ((_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.name) === PropertyChangedNameAndValueField().name) {
      options = options.map(option => {
        const {
          dataSensitivity
        } = option;
        if (dataSensitivity === 'high' || dataSensitivity === 'standard') {
          return Object.assign({}, option, {
            disabled: true,
            icon: 'block'
          });
        }
        return option;
      });
    }

    // Hide certain properties for the property value changed event to prevent high number of workflows triggers
    if (hasPropertyValueChangedRestrictions(getIsUngated)) {
      var _condition$field2;
      if (((_condition$field2 = condition.field) === null || _condition$field2 === void 0 ? void 0 : _condition$field2.name) === PropertyChangedNameAndValueField().name) {
        options = options.filter(option => {
          const {
            value
          } = option;
          return !PropertyValueChangedRestrictedProperties.includes(value);
        });
      }
    }
    const selectedFilterFieldOption = options.find(o => {
      var _condition$field3;
      return o.value === ((_condition$field3 = condition.field) === null || _condition$field3 === void 0 ? void 0 : _condition$field3.name);
    });
    if (selectedFilterFieldOption) {
      selectedFilterFieldOption.disabled = true;
    }
    return options;
  }

  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'nextValue' implicitly has an 'any... Remove this comment to see the full error message

  render() {
    const {
      condition,
      disabled,
      inputUse,
      fieldName,
      placeholder,
      readOnly,
      error
    } = this.props;
    const isError = error.get('error');
    const errorMessage = error.get('message');
    return /*#__PURE__*/_jsx(FormControl, {
      "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
      error: isError,
      validationMessage: isError ? errorMessage : null,
      children: /*#__PURE__*/_jsx(Select, {
        disabled: disabled,
        error: this.state.loading ? false : undefined,
        buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
        itemComponent: FilterOperatorPropertyInputOption,
        onChange: this.handleChange,
        onOpenChange: this.onOpenChange,
        options: this.getOptions(),
        placeholder: placeholder,
        readOnly: readOnly,
        inputRef: this.inputRef
        //@ts-expect-error `get` returns `unknown` type
        ,
        value: condition.get(fieldName)
      })
    });
  }
}
FilterOperatorPropertyInput.defaultProps = {
  fieldName: 'value'
};
FilterOperatorPropertyInput.propTypes = {
  condition: FilterOperatorType.isRequired,
  disabled: PropTypes.bool,
  error: FilterOperatorErrorType.isRequired,
  fieldName: PropTypes.string.isRequired,
  inputUse: PropTypes.oneOf(['on-dark']),
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  resolver: ReferenceResolverType,
  getIsUngated: PropTypes.func.isRequired
};
export default FilterOperatorPropertyInput;